import Swiper, {Navigation, Pagination, EffectCoverflow} from 'swiper';


var hero_slider_v3 = jQuery(".js-hero-slider-v3")


jQuery(document).ready(function () {
    if (hero_slider_v3.length) {
        Swiper.use([Navigation, Pagination, EffectCoverflow]);
        // Params
        const heroSliderSwiperV3 = new Swiper('.js-hero-slider-v3', {
            loop: true,
            effect: 'coverflow',
            centeredSlides: true,
            grabCursor: true,

            slidesPerView: "auto",

            coverflowEffect: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: .8,
                slideShadows: true,
            },
            breakpoints: {
                576: {
                    coverflowEffect: {
                        rotate: 50,
                        stretch: 0,
                        depth: 100,
                        modifier: 1,
                        slideShadows: true,
                    },
                },

                1800: {
                    coverflowEffect: {
                        rotate: 30,
                        stretch: -60,
                        depth: 10,
                        modifier: .8,
                        slideShadows: true,
                    },
                },
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },

            navigation: {
                nextEl: '.hero-slider-v3-button-next',
                prevEl: '.hero-slider-v3-button-prev',
            },
        });

        // Number of slides in swiper slider, not including duplicated slides (for loop param)
        const heroSliderV3SlideCount = heroSliderSwiperV3.slides.length - heroSliderSwiperV3.loopedSlides * 2

        function changeSliderNumbers() {

            var slideNumberList = document.querySelectorAll('.js-hero-slide-v3-number-slides');

            for (var i = 0; i < slideNumberList.length; i++) {
                const element = slideNumberList[i]

                // Add counter text to every element inside each slide
                element.innerHTML = (heroSliderSwiperV3.realIndex + 1) + '/' + (heroSliderV3SlideCount);
            }

            // Add counter text to element outside slide
            document.getElementById('hero_slider_v3_count_mob').innerHTML = (heroSliderSwiperV3.realIndex + 1) + '/' + (heroSliderV3SlideCount);

        }

        changeSliderNumbers();

        // Listen for slide change
        heroSliderSwiperV3.on('slideChange', function () {
            changeSliderNumbers();
        });
    }
})
